import { render, staticRenderFns } from "./NegociacaoAlterarRespostaDadosBasicos.vue?vue&type=template&id=1966940a"
import script from "./NegociacaoAlterarRespostaDadosBasicos.vue?vue&type=script&lang=js"
export * from "./NegociacaoAlterarRespostaDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports